import { HttpClient, URL_API } from "../../network";

export type TTransaction = {
  _id: string;
  User: User;
  amount: number;
  transaction_id: string;
  type: string;
  payment_type: string;
  is_paid: boolean;
  status: string;
  ChargeSession: ChargeSession | string;
  gst: number;
  createdAt: string;
  CPO: User[];
  SeedingPartner: User[];
  user_name: string;
  chargepoint_name: string;
  evse_name: string;
  charge_session_id: string;
  charging_fee_with_gst: number;
  idling_fee_with_gst: number;
  description?: string;
  is_refunded?: boolean;
  refunded_at?: string | null;
  refunded_amount?: number;
  payment_info?: CardInfo | string;
  admin_name?: string;
  reason?: string;
  charging_fee?: number;
  idling_fee?: number;
  crossover_fee?: number;
};

export interface CardInfo {
  exp_month: number;
  exp_year: number;
  last4: string;
}
interface ChargeSession {
  _id: string;
  session_started_at: string;
  session_ended_at: string;
}
interface User {
  _id: string;
  name: string;
  phone: string;
  email: string;
}

export type ChargeUserPayload = {
  type: "charge_session" | "topup";
  user_id: string;
  amount: number;
  reason: string;
  charge_session_id?: string;
};

class Transaction extends HttpClient {
  getAll = async (params: TParams) => {
    const data = await this.instance.get<IResponse<Array<TTransaction>>>(
      URL_API.TRANSACTIONS.GET_LIST,
      {
        params,
      }
    );
    return data;
  };


  getDetail = async (id: string) => {
    const { data } = await this.instance.get<IResponse<Partial<TTransaction>>>(
      URL_API.TRANSACTIONS.GET_DETAIL + id
    );
    return data;
  };

  deleteTransaction = async (transactionId: string, reasonDelete: string) => {
  return this.instance.delete(
    `${URL_API.TRANSACTIONS.DELETE}${transactionId}`,
    {
      data: {
        reason_delete: reasonDelete
      }
    }
  );
};
  chargeUser = async (payload: ChargeUserPayload) => {
    const { data } = await this.instance.post(
      URL_API.TRANSACTIONS.CHARGE_USER,
      payload
    );
    return data;
  };
}
export const TransactionService = new Transaction();
